module.exports = __webpack_public_path__ + "img/profile-circle.81c76afa.svg";